import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faImage, faVideo, faHeadphones, faFileAlt } from '@fortawesome/free-solid-svg-icons';

const ComposerFilePreview = ({ filePreview, onRemoveFile, isDark }) => {
  if (!filePreview) return null;

  const renderIcon = () => {
    if (filePreview.type === 'image' && filePreview.url) {
      return (
        <img
          src={filePreview.url}
          alt="Preview"
          style={{ width: '42px', height: '42px', objectFit: 'cover', borderRadius: '6px' }}
        />
      );
    }
    if (filePreview.type === 'video') {
      return (
        <div className="bg-dark text-white rounded d-flex align-items-center justify-content-center" style={{ width: '42px', height: '42px' }}>
          <FontAwesomeIcon icon={faVideo} />
        </div>
      );
    }
    if (filePreview.type === 'audio') {
      return (
        <div className="rounded d-flex align-items-center justify-content-center" style={{ width: '42px', height: '42px', backgroundColor: '#ea580c', color: '#ffffff' }}>
          <FontAwesomeIcon icon={faHeadphones} />
        </div>
      );
    }
    return (
      <div className="rounded d-flex align-items-center justify-content-center" style={{ width: '42px', height: '42px', backgroundColor: '#8b5cf6', color: '#ffffff' }}>
        <FontAwesomeIcon icon={faFileAlt} />
      </div>
    );
  };

  const formatFileSize = bytes => {
    if (!bytes) return '';
    const mb = bytes / (1024 * 1024);
    if (mb < 1) {
      return `${(bytes / 1024).toFixed(0)} KB`;
    }
    return `${mb.toFixed(1)} MB`;
  };

  const getSubLabel = () => {
    const sizeStr = filePreview.size ? ` (${formatFileSize(filePreview.size)})` : '';
    if (filePreview.type === 'image') return `Foto lista para enviar${sizeStr} · Máx 5 MB`;
    if (filePreview.type === 'video') return `Video listo para enviar${sizeStr} · Máx 16 MB`;
    if (filePreview.type === 'audio') return `Audio listo para enviar${sizeStr} · Máx 16 MB`;
    return `Documento listo para enviar${sizeStr} · Máx 100 MB`;
  };

  return (
    <div
      className="p-2 px-3 border-bottom d-flex align-items-center justify-content-between"
      style={{
        backgroundColor: isDark ? '#182635' : '#f8fafc',
        borderColor: isDark ? '#233142' : '#e2e8f0'
      }}
    >
      <div className="d-flex align-items-center gap-2 overflow-hidden">
        {renderIcon()}
        <div className="d-flex flex-column">
          <span className="fw-semibold text-truncate" style={{ fontSize: '0.82rem', maxWidth: '300px' }}>
            {filePreview.name}
          </span>
          <small className="text-muted" style={{ fontSize: '0.72rem' }}>
            {getSubLabel()}
          </small>
        </div>
      </div>
      <button
        type="button"
        className="btn btn-sm btn-link text-danger p-1 shadow-none"
        onClick={onRemoveFile}
        title="Quitar archivo"
      >
        <FontAwesomeIcon icon={faTimes} />
      </button>
    </div>
  );
};

ComposerFilePreview.propTypes = {
  filePreview: PropTypes.object,
  onRemoveFile: PropTypes.func.isRequired,
  isDark: PropTypes.bool
};

export default ComposerFilePreview;
